export var ConfigModuleCategory;
(function (ConfigModuleCategory) {
    ConfigModuleCategory["COPY"] = "ConfigModuleCategory.COPY";
    ConfigModuleCategory["DEPENDENCY"] = "ConfigModuleCategory.DEPENDENCY";
    ConfigModuleCategory["PLUGIN"] = "ConfigModuleCategory.PLUGIN";
    ConfigModuleCategory["SETTINGS"] = "ConfigModuleCategory.SETTINGS";
    ConfigModuleCategory["VIEW"] = "ConfigModuleCategory.VIEW";
    ConfigModuleCategory["HOOK"] = "ConfigModuleCategory.HOOK";
    ConfigModuleCategory["RESOURCE"] = "ConfigModuleCategory.RESOURCE";
})(ConfigModuleCategory || (ConfigModuleCategory = {}));
